<template>
  <section class="hbox stretch">
    <div class="content-main">
      <el-table :data="rows" style="width: 100%" :row-class-name="getRowClass">
          <el-table-column  prop="children" fixed="left" label="" type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.children" border fit highlight-current-row>
                <el-table-column prop="Name" label="名称" sortable></el-table-column>
                <el-table-column prop="Price" label="原价"></el-table-column>
                <el-table-column prop="PreferentialFee" label="优惠金额"></el-table-column>
                <el-table-column prop="Number" label="数量"></el-table-column>
                <el-table-column prop="TotalMomey" label="合计"></el-table-column>
                <el-table-column prop="Attach" label="备注"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column  prop="BillNumber" :show-overflow-tooltip="true" fixed="left" label="单据号"></el-table-column>
          <el-table-column  prop="StoreName"  :show-overflow-tooltip="true"  label="店铺名称"> </el-table-column>
          <el-table-column  prop="MemberName"  label="会员名称"> </el-table-column>
          <el-table-column  prop="PaidInfo_ReceivableAmount"  label="应收金额"> </el-table-column>
          <el-table-column  prop="PaidInfo_ReceiptAmount"  label="实收金额"  > </el-table-column>
          <el-table-column  prop="PaidInfo_WxPaid"  label="微信支付"  > </el-table-column>
          <el-table-column  prop="PaidInfo_AliPaid"  label="支付宝支付"  > </el-table-column>
          <el-table-column  prop="PaidInfo_PointPaid"  label="积分支付"  > </el-table-column>
          <el-table-column  prop="PaidInfo_ValuePaid"  label="储值支付"  > </el-table-column>
          <el-table-column  prop="PaidInfo_CashPaid"  label="现金支付"  > </el-table-column>
          <el-table-column  prop="PaidInfo_RewardPaid"  label="奖励金支付"  > </el-table-column>
          <el-table-column  prop="UserAccount"  label="操作员"   ></el-table-column>
          <el-table-column  prop="CreateTime"  width="120px" label="操作时间" :formatter="dateFormat"> </el-table-column>
        </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
        :current-page="serch.pageIndex"
        :page-size="serch.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="serch.totalCount">
      </el-pagination>
    </div>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {    
    props:{
      memberId:0
    },
    data (){
      return {
        name:'',
        rows:[],
        serch:{
          pageIndex:1,
          pagesize:10,
          totalCount:0,
          memberId:0,
          sort:'Id desc',
        }
      }
    },
    components:{          
    },    
    watch:{
      memberId(newV,oldV){
        this.serch.memberId = newV
        this.serch.pageIndex = 1
        this.GetData()
      }
    },
    computed:{
    },
    mounted(){
    },
    methods:{    
      getRowClass: function (row,rowIndex) {
        if(row.row.Children.length==0){  //判断当前行是否有子数据或者根据实际情况设置
          return 'row-expand-cover'
        }
      }, 
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Statistical/ConsumeNote',
          params: that.serch
        }).then(function (resp) {
          that.serch.totalCount = resp.data.totalCount
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleCurrentChange(val) {
        this.serch.pageIndex = val
        this.GetData()
      }
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.map
  width: 100%;
  height: 200px;
.el-table .row-expand-cover .cell .el-table__expand-icon {
  display: none;
}
</style>